import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, provideDefaultConfig, UrlModule } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { UserPermissionsGuard } from '../../../../../../guards/user-permissions.guard'
import { SharedModule } from '../../../../../shared/shared.module'
import { DispenserShipmentHistoryComponent } from './dispenser-shipment-history.component'

@NgModule({
  declarations: [DispenserShipmentHistoryComponent],
  imports: [RouterModule, UrlModule, SharedModule, SpinnerModule],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        DispenserAgreementShipmentHistoryComponent: {
          component: DispenserShipmentHistoryComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class DispenserShipmentHistoryModule {}
